import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Helmet from 'react-helmet';

import styled from 'styled-components'
import cssVar from '../styles/variables'
import { ScrollHint, ScrollHintIcon, ScrollHintText, HeroSectionText, HeroContentWrapper, FullSizeBackgroundVideo, SlimSection, Heading4, LinkText, FullAreaWrapper, PrimaryButton, SecondaryButton, Text, Link, withColor, Heading2, Heading3, BiggerText, H1, GridRow, FullWidthWrapper, Section, FullWidthSection, HeroSection, Heading1, MaxContentWidthContainer, MaxContentWidthWrapper } from '../components/marketing/MarketingStyles';

import Benefits from '../components/marketing/BenefitsSection'
import Press from '../components/marketing/PressSection'
import Testimonials from '../components/marketing/TestimonialSection'
import Partners from '../components/marketing/PartnerSection'
import RequestInformation from '../components/marketing/RequestInformationSection'
import PromotionVideo from '../components/marketing/PromotionVideoSection'
import Pricing from '../components/marketing/PricingSection'
import LimitedAccess from '../components/marketing/LimitedAccessSection'
import Motivation from '../components/marketing/MotivationSection'
import GolfCourseMap from '../components/marketing/GolfCourseMap'
import QandA from '../components/marketing/QandASection'
import CtaBox from '../components/marketing/CtaBox'

import Logo from '../images/logo.png'
import FlyOverArrow from '../images/icons/arrow-flyover.png'
import DiscoverMoreArrow from '../images/icons/arrow-discover-more.svg'

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { inject, observer, Observer } from 'mobx-react'

import { trackEvent } from "../utils/eventTracking"

@inject('golfCourseStore', 'modalStore', 'translationStore')
@observer
class Home extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pressIndex: 1
    }
  }

  componentDidMount() {
    this.props.golfCourseStore.getGolfCourses()

    console.log('location', window.location.hash);
    const hash = window.location.hash
    
    if(hash) {

      document.querySelector(hash)
        .scrollIntoView({ behavior: 'smooth' });

      setTimeout(() => {
        document.querySelector(hash)
          .scrollIntoView({ behavior: 'smooth' });
      }, 1000)
      
    }
  }

  render() {

    // console.log('RERENDER!');

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    console.log(this.props.translationStore.t)

    // const BookAppointmentSection = ( ) => (
    //   <SlimSection>
    //     <CtaBox
    //       title="Jetzt Termin vereinbaren"
    //       text="Vereinbaren Sie einen persönlichen Gesprächstermin mit einem unserer Geschäftsführer."
    //       buttonText="Jetzt Termin vereinbaren"
    //       buttonLink="make_appointment_target"
    //       onClick={ () => trackEvent( 'Arrange Meeting - Footer - CTA Section', 'Meeting', 'Click Button' ) }
    //     />
    //   </SlimSection>
    // )

    const metaData = [
      { name: 'description', content: "Tauchen Sie ein in ein Netzwerk mit Persönlichkeiten aus der Wirtschaft, Politik, Medien und Sport und teilen Sie Ihre Begeisterung für Ihr Business und den Golfsport | berwerben Sie sich jetzt" },
      { property: 'og:title', content: "THE LOGE | exclusive business & lifestyle network" },
      { property: 'twitter:title', content: "THE LOGE | exclusive business & lifestyle network" },
      { property: 'og:description', content: "Tauchen Sie ein in ein Netzwerk mit Persönlichkeiten aus der Wirtschaft, Politik, Medien und Sport und teilen Sie Ihre Begeisterung für Ihr Business und den Golfsport | berwerben Sie sich jetzt" },
      { property: 'twitter:description', content: "Tauchen Sie ein in ein Netzwerk mit Persönlichkeiten aus der Wirtschaft, Politik, Medien und Sport und teilen Sie Ihre Begeisterung für Ihr Business und den Golfsport | berwerben Sie sich jetzt" },
      { property: 'og:image', content: "https://images.unsplash.com/photo-1500932334442-8761ee4810a7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" },
      { property: 'twitter:image', content: "https://images.unsplash.com/photo-1500932334442-8761ee4810a7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" },
    ]

    console.log(this.props.golfCourseStore);

    const courseCount = this.props.golfCourseStore.golfCoursesCount
    const leadingCourseCount = this.props.golfCourseStore.leadingGolfCoursesCount

    return (
      <FullWidthWrapper>
        <Helmet meta={ metaData } />
        <HeroSection>
          <FullSizeBackgroundVideo>
            <video loop="true" autoPlay="true" muted="true" playsInline="true">
              <source src="https://the-loge-data.fra1.digitaloceanspaces.com/marketing/videos/Hero-Section-Video-home.mp4" type="video/mp4" />
            </video>
          </FullSizeBackgroundVideo>
          <MaxContentWidthWrapper style={{height: '100%'}}>
            <MaxContentWidthContainer style={{height: '100%'}}>
              <GridRow
                desktop="1fr 1fr"
                tablet="1fr"
                phone="1fr"
                style={{height: '100%'}}
              >
                <HeroContentWrapper>
                  <H1 color="#FFFFFF" dangerouslySetInnerHTML={{__html: text('marketing_hero_headline').replace('\n', '<br>')}}></H1>
                  <HeroSectionText>
                    { text('marketing_hero_subheadline') }
                  </HeroSectionText>
                  <GridRow
                    desktop="auto auto"
                    phone="1fr"
                    phoneRowGap
                  >
                    <div>
                      <PrimaryButton value={text('marketing_hero_button')} onClick={ () => { this.props.modalStore.setState('request_information', true); trackEvent( 'Request Information - Hero', 'Advertisment', 'Click Button' ) } } autoWidth />
                    </div>
                    {/* <div>
                      <SecondaryButton value="Mehr Infos" onClick={ () => { this.props.modalStore.setState('request_information', true); trackEvent( 'Request Information - Herosection', 'Advertisment', 'Click Button' ) }} autoWidth/>
                    </div> */}
                  </GridRow>
                </HeroContentWrapper>
              </GridRow>
            </MaxContentWidthContainer>
          </MaxContentWidthWrapper>
          <ScrollHint onClick={ () => this.startOfPage.scrollIntoView()}>
            <ScrollHintText>{ text('marketing_hero_more') }</ScrollHintText>
            <ScrollHintIcon src={ DiscoverMoreArrow } />
          </ScrollHint>
        </HeroSection>

        <div ref={ (ref) => this.startOfPage=ref }></div>

        <Section id="about">
          <GridRow
            desktop="1fr 1fr"
            tablet="1fr"
          >
            <div>
              <Heading1>{ text('marketing_about_headline') }</Heading1>
              <BiggerText>
                { text('marketing_about_text') }
              </BiggerText>
            </div>
          </GridRow>
        </Section>

        <AboutListSection>
          <AboutListGridRow>
            <AboutListIcon src={require('../images/about/network.png')} />
            <AboutHeading>{ text('marketing_about_point1_headline') }</AboutHeading>
            <AboutText>
              { text('marketing_about_point1_text') }
            </AboutText>
            <AboutLink href={'#partners'} onClick={ () => trackEvent( 'Request Information - About - "Unsere Partner"', 'Advertisment', 'Click Button' ) }>{ text('marketing_about_point1_button') }</AboutLink>
          </AboutListGridRow>
          <AboutListGridRow>
            <AboutListIcon src={require('../images/about/cal.png')} />
            <AboutHeading>{ text('marketing_about_point2_headline') }</AboutHeading>
            <AboutText>
            { text('marketing_about_point2_text') }
            </AboutText>
            <AboutLink onClick={ () => { this.props.modalStore.setState('request_information', true); trackEvent( 'Request Information - About - "Kontakt aufnehmen"', 'Advertisment', 'Click Button' ) }}>{ text('marketing_about_point2_button') }</AboutLink>
          </AboutListGridRow>
          <AboutListGridRow>
            <AboutListIcon src={require('../images/about/discount.png')} />
            <AboutHeading>{ text('marketing_about_point3_headline') }</AboutHeading>
            <AboutText>
            { text('marketing_about_point3_text') }
            </AboutText>
            <AboutLink onClick={ () => { this.beforePricingSection.scrollIntoView() } }>{ text('marketing_about_point3_button') }</AboutLink>
          </AboutListGridRow>
        </AboutListSection>

        <Benefits scrollToCta={ () => { this.props.modalStore.setState('request_information', true); trackEvent( 'Request Information - Benefits', 'Advertisment', 'Click Button' ) }}  />


        <MaxContentWidthWrapper>
          <MaxContentWidthContainer>
            <GridRow
              desktop="1fr 1fr"
              tablet="1fr"
            >
              <div>
                <Heading1>{ text('marketing_video_headline') }</Heading1>
                <BiggerText>{ text('marketing_video_subheadline') }</BiggerText>
              </div>
            </GridRow>
          </MaxContentWidthContainer>
        </MaxContentWidthWrapper>

        <PromotionVideo />

        <MaxContentWidthWrapper style={{ padding: '6em 0' }} id="golfcourses">
          <MaxContentWidthContainer>
            <GridRow
              desktop="1fr 1fr"
              tablet="1fr"
            >
              <div>
                <Heading1>{ text('marketing_map_headline') }</Heading1>
                <BiggerText>{courseCount + ' ' + text('marketing_map_subheadline1') + ' ' + leadingCourseCount + ' ' + text('marketing_map_subheadline2')}</BiggerText>
              </div>
            </GridRow>
          </MaxContentWidthContainer>
        </MaxContentWidthWrapper>

        <GolfCourseMapWrapper>
          <GolfCourseMap showPanel={true} />
        </GolfCourseMapWrapper>

        <LimitedAccess scrollToCta={ () => this.beforePricingSection.scrollIntoView() } />
        <Testimonials scrollToCta={ () => { this.props.modalStore.setState('request_information', true); trackEvent( 'Request Information - Testimonials', 'Advertisment', 'Click Button' ) }}  />
        <RequestInformation />
        <Partners/>
        <Motivation />
        <Press />
        <div ref={ (ref) => this.beforePricingSection=ref }></div>
        <Pricing />

        <SlimSection>
          <CtaBox
            title={ text('marketing_cta_box_headline') }
            text={ text('marketing_cta_box_text') }
            buttonText={ text('marketing_cta_box_button') }
            buttonLink="/bewerbung"
            onClick={ () => trackEvent( 'Apply - Footer - CTA Section', 'Application', 'Click Button' )}
          />
        </SlimSection>
      
        <FullWidthSection id="team">
          <TeamGridRow
            desktop="1fr 1fr"
            phone="1fr" phoneRowGap
          >
            <TeamContent>
              <Heading1>{ text('marketing_team_headline') }</Heading1>
              <BiggerText>{ text('marketing_team_line1') }</BiggerText>
              <TeamQuoteText>{ text('marketing_team_line2') }</TeamQuoteText>
              <BiggerText>{ text('marketing_team_line3') }</BiggerText>
                <TeamItem>
                  <TeamName>Mag. Gerald Enderle, MBA</TeamName>
                  <TeamPosition>CMO, Co-Founder</TeamPosition>
                  <TeamLink onClick={ e => { e.preventDefault(); window.open("mailto:g.enderle[at]the-loge.com".replace("[at]", "@"), "_blank") } }>g.enderle [at] the-loge.com</TeamLink>
                  <TeamLink href="tel:+4369918790755">+43 699 187 90 755</TeamLink>
                </TeamItem>
              <TeamItem>
                <TeamName>Thomas Schnöll</TeamName>
                <TeamPosition>CEO, Co-Founder</TeamPosition>
                <TeamLink onClick={ e => { e.preventDefault(); window.open("mailto:t.schnoell[at]the-loge.com".replace("[at]", "@"), "_blank") } }>t.schnoell [at] the-loge.com</TeamLink>
                <TeamLink href="tel:+436769444481">+43 676 94 44 481</TeamLink>
              </TeamItem>
            </TeamContent>
            <TeamImageWrapper>
              <TeamImage src="https://res.cloudinary.com/theloge/image/upload/w_800/q_auto:good/v1627984727/marketing/team_image.jpg" />
            </TeamImageWrapper>
          </TeamGridRow>
        </FullWidthSection>
                    
        <QandA />

        <FlyOver onClick={ () => { this.props.history.push('/bewerbung'); trackEvent( 'Apply - Sticky Badge', 'Application', 'Click Button' ) } }>
          <FlyOverIcon src={ FlyOverArrow } />
          <FlyOverLogo src={ Logo } />
          <FlyOverText>{ text('marketing_start_application') }</FlyOverText>
        </FlyOver>
      </FullWidthWrapper>
    )
  }
}

export default withRouter(Home)

const GolfCourseMapWrapper = styled(FullWidthSection) `
  height: 800px;

  ${cssVar.breakpoints.tablet} {
    height: auto;
  }
`

const TeamQuoteText = styled(BiggerText)`
  font-weight: bold;
  font-size: 24px;
  line-height: 24px;
`


const FlyOver = styled.div `
  background: ${ cssVar.colors.blue };
  height: 90px;
  border-radius: 45px 0 0 45px;
  position: fixed;
  right: 0;
  bottom: 50px;
  margin-right: -250px;
  transition: all ${ cssVar.transitions.basic };
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  box-shadow: rgba(0,0,0,0.2) 0 0 5px;

  :hover {
    margin-right: 0;
  }

  ${cssVar.breakpoints.tablet} {
    display: none;
  }
`

const FlyOverIcon = styled.img `
  width: 15px;
  margin: 20px;
  object-fit: contain;
`

const FlyOverLogo = styled.img `
  width: 90px;
  padding: 15px;
  margin-right: 10px;
`

const FlyOverText = styled.div `
  width: 250px;
  color: ${ cssVar.colors.gold };
  text-decoration: underline;
  text-transform: uppercase;
  text-align: center;
  font-family: 'Supreme-Regular';
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.03em;
`

const TeamGridRow = styled(GridRow) `
  grid-template-rows: 1fr;

  ${cssVar.breakpoints.tablet} {
    grid-template-rows: auto auto;
  }
`

const TeamImageWrapper = styled(GridRow) `
  width: 100%;
  padding-top: 133%;
  position: relative;
  margin-left: 30px;

  ${cssVar.breakpoints.phone} {
    margin: 0;
    padding: 0;
  }
`

const TeamContent = styled.div `
  max-width: ${cssVar.max_content_width / 2 - 10 + 50}px; /* -10px to account for grid row gap */
  width: 100%;
  margin: 0 0 0 auto;
  padding: 100px 50px;

  ${cssVar.breakpoints.phone} {
    padding: 0 30px 30px 30px;
  }
`

const TeamImage = styled.img `
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  object-position: 100% 50%;

  ${cssVar.breakpoints.phone} {
    position: static;
    object-fit: contain;
    ${'' /* transform: translateX(-50%); */}
    margin: 0 30px;
    width: calc(100% - 60px);
    height: auto;
  }
`
const TeamItem = styled.div `
  margin: 30px 50px;

  ${cssVar.breakpoints.tablet} {
    margin: 0;
  }
`
const TeamName = styled(Heading2) `
  padding-bottom: 10px;
  font-size: 26px;
`
const TeamPosition = styled(Heading3) `
  text-transform: none;
`

const TeamLink = styled.a `
  display: block;
  font-family: 'Supreme-Regular';
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.02em;
  margin: 10px 0;
  text-decoration: none;
  cursor: pointer;
  color: ${ cssVar.colors.blue };

  :hover {
    text-decoration: underline;
    color: ${ cssVar.colors.blue };
  }
`

const GreyText = withColor(Text, cssVar.colors.grey)
const GreyLink = withColor(Link, cssVar.colors.grey)

const AboutListSection = styled(Section) `
  ${cssVar.breakpoints.phone} {
    padding-top: 0;
  }
`

const AboutLink = styled(GreyLink) `
  padding: 0;
  padding-left: 20px;
  text-align: right;
  width: 100%;

  ${cssVar.breakpoints.tablet} {
    text-align: center;
    grid-area: cta;
    padding: 0;
  }

  ${cssVar.breakpoints.phone} {
    text-align: left;
    grid-area: cta;
  }
`

const AboutListGridRow = styled(GridRow) `
  grid-template-columns: 2fr 2fr 5fr 2fr;
  padding: 30px 0;
  border-top: 2px solid ${ cssVar.colors.gold };

  ${cssVar.breakpoints.tablet} {
    grid-template-columns: auto 1fr;
    grid-template-areas: "icon title" "text text" "cta cta";
  }
`

const AboutHeading = styled(Heading2) `
  padding: 0;

  ${cssVar.breakpoints.tablet} {
    grid-area: title;
    height: 100%;
    display: flex;
    align-items: center;
  }
`

const AboutText = styled(GreyText) `
  padding: 0;

  ${cssVar.breakpoints.tablet} {
    grid-area: text;
    padding: 20px 0;
  }
`

const AboutListIcon = styled.img `
  width: 100%;
  height: 100%;
  max-width: 50px;
  max-height: 50px;
  margin: 0 20px;
  object-fit: contain;

  ${cssVar.breakpoints.tablet} {
    grid-area: icon;
  }
`



// WEBPACK FOOTER //
// /src/pages/Home.js